import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api";

export default function CaseStudyPracticeList() {
  const [list, setList] = useState([]);
  const nav = useNavigate();

  const load = () => {
    api.get("/admin/case-study-practice/list")
      .then(res => setList(res.data || []));
  };

  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this practice set?")) return;
    await api.delete(`/admin/case-study-practice/${id}`);
    load();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📘 Case Study Practice Sets</h2>

      <button onClick={() => nav("/admin/case-study-practice")}>
        ➕ Create New
      </button>

      <table style={table}>
        <thead>
          <tr>
            <th>Title</th>
            <th>Case Studies</th>
            <th>Duration</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {list.map(ps => (
            <tr key={ps.id}>
              <td>{ps.title}</td>
              <td>{ps.case_study_count}</td>
              <td>{ps.duration_minutes} min</td>
              <td>
                <button onClick={() => nav(`/admin/case-study-practice/${ps.id}/view`)}>
                  View
                </button>
                <button onClick={() => nav(`/admin/case-study-practice/${ps.id}/edit`)}>
                  Edit
                </button>
                <button
                  onClick={() => remove(ps.id)}
                  style={{ color: "red" }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const table = {
  width: "100%",
  borderCollapse: "collapse",
};
